<template>
  <div>
    <b-row>
      <b-col
          :md="this.$route.params.id == 0 ? 12 : 4"
          :xl="this.$route.params.id == 0 ? 12 : 4"
          class="mb-1"
      >
        <b-col
          xl="12">
          <b-card-code title="Allgemeine Informationen">
            <b-row>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-row>
                  <b-col
                      md="8"
                      xl="8"
                  >
                    <b-form-group
                        label="Addresskennung (ID) (Leer für Automatisch)"
                    >
                      <b-form-input
                          v-model="address.AddressId"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col
                      md="12"
                      xl="12"
                  >
                    <b-form-group
                        label="Kontaktname (Name, Vorname)"
                    >
                      <b-form-input
                          v-model="address.Contact.Name"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                  md="6"
                  xl="6"
              >

              </b-col>
            </b-row>
          </b-card-code>
        </b-col>

        <b-col
            xl="12">
          <b-card-code
              title="Adressinformationen"
          >
            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Postleitzahl"
                >
                  <b-form-input
                      v-model="address.Address.ZipCode"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="8"
                  xl="8"
              >
                <b-form-group
                    label="Ort"
                >
                  <b-form-input
                      v-model="address.Address.Location"
                  />
                </b-form-group>
              </b-col>
            </b-row>


            <b-row>
              <b-col
                  md="12"
                  xl="12"
              >
                <b-form-group
                    label="Strasse"
                >
                  <b-form-input
                      v-model="address.Address.Street"
                      @blur="ClosePopover"
                      @keyup="OpenPopover"
                      id="StreetPopover"
                  />
                </b-form-group>
              </b-col>
            </b-row>

          </b-card-code>
        </b-col>

        <b-col
            xl="12">
          <b-card-code title="Kontaktinformationen">

            <b-row>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Telefon"
                >
                  <b-form-input
                      v-model="address.Contact.Phone"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Telefon"
                >
                  <b-form-input
                      v-model="address.Contact.Phone2"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
              >
                <b-form-group
                    label="Fax"
                >
                  <b-form-input
                      v-model="address.Contact.Fax"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-form-group
                    label="Email"
                >
                  <b-form-input
                      v-model="address.Contact.Email"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-form-group
                    label="Webseite"
                >
                  <b-form-input
                      v-model="address.Contact.Web"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-code>
        </b-col>
        <b-col>
          <b-card-code>
            <b-button
                class="col-4"
                variant="danger"
                @click="DeleteEntry()"
            >
              <span v-show="!loading"> Löschen </span>
              <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
              <div
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </b-button>
            <b-button
                style="float: right"
                class="col-7"
                variant="info"
                @click="Save()"
            >
              <span v-show="!loading && this.address.AddressIdentId > 0"> Speichern  </span>
              <span v-show="!loading && this.address.AddressIdentId == 0"> Eintrag anlegen  </span>
              <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
              <div
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                  role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </b-button>
          </b-card-code>
        </b-col>
      </b-col>

      <b-col
          :md="this.$route.params.id == 0 ? 12 : 8"
          :xl="this.$route.params.id == 0 ? 12 : 8"
          class="mb-1"
          v-show="(this.$route.params.id == 0 ? false : true)"
      >

        <b-card-code title="Dateien">
          <b-row>
            <b-col
                cols="12"
            >
              <b-button @click="$root.$emit('OpenFileMenu', 1, address.AddressIdentId)">Neue Datei</b-button>
              <FileBoxedView class="mt-2" ref="addressFileView"></FileBoxedView>
            </b-col>
          </b-row>
        </b-card-code>

        <b-card-code title="History">
          <b-row>
            <b-col
                cols="12"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  align="center"
                  size="sm"
                  class="my-0"
              />
            <b-table
                striped
                hover
                responsive
                :items="history"
                :fields="fields"
                @filtered="onFiltered"
                @row-clicked="clickVoucher"
            >
              <template #cell(Drivers)="data">
              </template>
              <template #cell(Vid)="data">{{ data.item.Vid }}
                <feather-icon
                    v-show="data.item.BillNumber != ''"
                    icon="LockIcon"
                    size="12"
                />
                <b-badge
                    v-show="data.item.Canceled != null && data.item.Canceled == true"
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    v-b-tooltip.hover.v-primary
                    :title="(data.item.Canceled + ' ('+data.item.CanceledUser+')')"
                    variant="warning"
                >Storniert
                </b-badge>
              </template>
              <template #cell(PickupTime)="data">
                {{data.item.TravelDay}} - {{data.item.PickupTime}}
              </template>
              <template #cell(Passenger)="data">
                {{data.item.Passenger.Passengers}} / {{data.item.Passenger.PassengersChildren}}
              </template>
              <template #cell(Route)="data">
                {{data.item.PickUpAddress.Name}} => {{data.item.DestinationAddress.Name}}
              </template>
              <template #cell(Price)="data">
                <b-badge
                    variant="light-info"
                >{{data.item.Price.PriceFull}}
                </b-badge>
              </template>
            </b-table>

            </b-col>
          </b-row>
        </b-card-code>
      </b-col>
    </b-row>

    <b-popover
        ref="popover"
        target="StreetPopover"
        :show.sync="popover.show"
        :disabled.sync="popover.disabled"
        placement="bottom"
        container="my-container"
    >
      <template v-slot:title>
        <div class="d-flex justify-content-between align-items-center">
          <span>Adresssuche</span>
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="close"
              variant="transparent"
              aria-label="Close"
          >
            <span
                class="d-inline-block text-white"
                aria-hidden="true"
            >&times;</span>
          </b-button>
        </div>
      </template>

      <div>
        <b-table responsive="xl"
                 class="row-pointer"
                 :items="popover.filteredOptions"
                 :fields="popover.fields"
                 @row-clicked="SelectAddress"
        />
      </div>
    </b-popover>
  </div>
</template>


<script>
import BCardCode from '@core/components/b-card-code'
import { BAvatar, BBadge, BButton, BCol, BFormGroup, BFormInput, BFormSelect, BInputGroup, BInputGroupAppend, BPagination, BRow, BTable, BPopover, VBTooltip } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Ripple from 'vue-ripple-directive'
import 'animate.css'
import FileBoxedView from '@/layouts/components/FileBoxedView.vue'
export default {
  name: 'Customer',
  components: {
    FileBoxedView,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BPopover,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      loading: false,
      history: [],

      fields: [
        {
          key: 'Vid',
          label: 'V-Data',
        },
        {
          key: 'PickupTime',
          label: 'Abholung',
        },
        {
          key: 'Passenger',
          label: 'Personen',
        },
        {
          key: 'Price',
          label: 'Preis',
        },
        {
          key: 'Route',
          label: 'Strecke',
        },
        {
          key: 'Info',
          label: 'Info',
        },
      ],
      totalRows: 0,
      perPage: 50,
      currentPage: 1,
      popover: {
        show: false,
        disabled: false,
        timeout: null,
        filteredOptions: [],
        fields: [
          {
            key: 'Address',
            label: 'Addresse',
          },
        ],
      },
      place: {
        PlaceId : ""
      },
      address: {
        AddressIdentId: 0,
        AddressId: '',
        Address: {
          Street: '',
          ZipCode: '',
          Location: '',
          District: ''
        },
        Contact: {
          Name: '',
          Phone: '',
          Phone2: '',
          Fax: '',
          Email: '',
          Web: ''
        },
        Info: '',
        Coordinates: {
          lat: 51.42102,
          lng: 12.221834
        }
      }
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Adresse'
    })
    this.LoadCustomer()
    this.$watch(
        () => this.currentPage,
        val => {
          this.LoadHistory()
        },
    )
  },
  methods: {
    OpenPopover() {

      this.popover.show = true
      this.$nextTick(() => {
        clearTimeout(this.popover.timeout)
        this.popover.timeout = setTimeout(() => {
          this.SearchAddress()
        }, 500)
      })
    },
    ClosePopover() {
      setTimeout(() => {
        this.popover.show = false
      }, 500)
    },
    SelectAddress(searchString) {
      this.$http.post('/address/search/google', JSON.stringify({
        SearchString: searchString.Address,
      }))
          .then(resp => {
            if (resp.data.success) {
              this.address.Address.Street = resp.data.Address.Street
              this.address.Address.ZipCode = resp.data.Address.ZipCode
              this.address.Address.Location = resp.data.Address.Location
              this.address.Address.District = resp.data.Address.District
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    SearchAddress() {
      this.popover.filteredOptions = []
      this.$http.post('/address/search/address', JSON.stringify({
        Zipcode: this.address.Address.ZipCode,
        Location: this.address.Address.Location,
        Street: this.address.Address.Street,
      }))
          .then(resp => {
            if (resp.data.success) {
              resp.data.list.forEach(i => {
                this.popover.filteredOptions.push(i)
              })
            }
          })
          .catch(err => {
            console.error(err)
          })
    },
    DeleteEntry() {
      this.$swal({
        title: 'LÖSCHEN',
        text: 'Möchten sie diese Adresse ' + this.address.AddressId + ' wirklich löschen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, löschen!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.value) {
              this.$http.delete('address/delete/' + this.address.AddressIdentId)
                  .then(resp => {
                    if (resp.data.success) {
                      this.$swal({
                        icon: 'success',
                        title: 'Gelöscht!',
                        text: 'Addresse wurde unwiderruflich gelöscht.',
                        customClass: {
                          confirmButton: 'btn btn-success',
                        },
                      })

                      this.$router.push({ name: 'AddressTemplate' })

                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })

            }
          })
    },
    Add() {
      if (this.loading) {
        return
      }

      this.loading = true
      delete this.address.Id
      delete this.address.Coordinates
      this.$http.post('/address/add', JSON.stringify(this.address))
          .then(resp => {
            console.log(resp)
            if (resp.data.success) {
              if (resp.data.infoText != '') {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Info',
                    icon: 'CheckIcon',
                    text: 'Adresse wurde gespeichert. (' + resp.data.infoText + ')',
                    variant: 'warning',
                  },
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Info',
                    icon: 'CheckIcon',
                    text: 'Adresse wurde gespeichert.',
                    variant: 'success',
                  },
                })
              }

              this.$nextTick(() => {
                this.$router.push({
                  name: 'Address',
                  params: { id: resp.data.newId }
                })
              })
              this.address.AddressId = resp.data.addressId
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: resp.data.message,
                  variant: 'danger',
                },
              })
            }
            setTimeout(() => {
              this.loading = false
            }, 1500)
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
      console.log(this.customer)
    },
    Save() {
      if (this.address.AddressIdentId == 0) {
        this.Add()
      }

      if (this.loading) {
        return
      }

      this.loading = true
      delete this.address.Id
      delete this.address.Coordinates
      this.$http.post('/address/save', JSON.stringify(this.address))
          .then(resp => {
            console.log(resp)
            if (resp.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Adresse wurde gespeichert.',
                  variant: 'success',
                },
              })
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler',
                  icon: 'CheckIcon',
                  text: resp.data.message,
                  variant: 'danger',
                },
              })
            }
            setTimeout(() => {
              this.loading = false
            }, 1500)
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'CheckIcon',
                text: err,
                variant: 'danger',
              },
            })
          })
      console.log(this.customer)
    },

    clickVoucher(record, index) {
      this.$router.push({
        name: 'VoucherMask',
        params: { id: record.Vid }
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    LoadHistory() {
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `/voucher/by/address/list?from=${c1}&count=${this.perPage}`

      this.history = [];
      this.$http.get( url+ '&addressIdentId=' + this.$route.params.id)
          .then(resp => {
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {
              this.history.push(i)
            })
          })
          .catch(err => {
            console.error(err)
          })
    },
    LoadCustomer() {
      if (this.$route.params.id > 0) {
        this.LoadHistory();
        this.$http.get('/address/ident?identId=' + this.$route.params.id)
            .then(resp => {
              if (resp.status != 200) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Info',
                    icon: 'CheckIcon',
                    text: 'Server gibt einen Ungültigen Code zurück (' + resp.status + ').',
                    variant: 'success',
                  },
                })
                return
              }
              this.address = resp.data.address
              this.place = resp.data.place

              resp.data.address.ConnectTargets.forEach(i => {
                if(i.TargetType == 7) {
                  this.$refs.addressFileView.getFile(i.TargetId)
                }
              })
              //

              this.$nextTick(() => {
                document.title = 'Adr.: ' + this.address.AddressId
              })

            })
            .catch(err => {
              console.error(err)
            })
      }
    },
  }

}
</script>